import * as React from 'react';
import { hot } from 'react-hot-loader/root';
import { Route } from 'react-router';
import { BrowserRouter as Router } from 'react-router-dom';
import '../globalStyles';
import { GlobalFooter } from './GlobalFooter';
import { GlobalHeader } from './GlobalHeader';
import { Talks } from './Talks';

const Root = () => (
    <React.Fragment>
        <GlobalHeader />

        <Router>
            <Route path='/talks' component={Talks} />
        </Router>

        <GlobalFooter />
    </React.Fragment>
);

export default hot(Root);
